import React, {
  FC,
  PropsWithChildren
} from "react";
import styled from "styled-components";
import { FilterItem } from "./FilterItem";
// Importing the filters component
import FilterForm from "./FilterForm";




const CardContentWrapper = styled.div`
  padding: 1rem;
  flex-grow: 0;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    border-radius: 30px;
  }
  border-bottom: 1px solid #c0bebe;
`;

interface IFilterTemplate {
  label?: string;
  filters: { value: string; label: string }[];
  activeFilters: string[];
  handleFormChange: (event: InputEvent) => void;
  isMobile?: boolean;
  type?: string;
}

export const MobileFilterTemplate: FC<PropsWithChildren<IFilterTemplate>> = ({
  filters,
  activeFilters,
  handleFormChange,
  type,
}) => {
  return (
    <CardContentWrapper>
      <FilterForm>
        {filters.map(({ value, label }, index) => {
          const isInGlobal = activeFilters.includes(value);
          return (
            <FilterItem
              key={index}
              keyName={index}
              checked={isInGlobal}
              type={"radio"}
              gridColumnStyle={"1fr"}
              onClick={handleFormChange}
              filterType={type}
              value={value}
              label={label}
            />
          );
        })}
      </FilterForm>
    </CardContentWrapper>
  );
};
